import { Component, Input, inject } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-delete-btn',
  templateUrl: './delete-btn.component.html',
  styleUrls: ['./delete-btn.component.scss'],
  standalone: false
})
export class DeleteBtnComponent {
  auth = inject(AuthService);


  @Input() size: string;

}
